import DTO from './DTO';

class OsagoDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'vehicle_external_id',
        type: String,
        validators: [],
        labelKey: 'vehicle.external_id',
      },
      {
        name: 'vehicle_osago_series',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_series',
      },
      {
        name: 'vehicle_osago_number',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_number',
      },
      {
        name: 'vehicle_osago_valid_from_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_effective_date',
      },
      {
        name: 'vehicle_osago_valid_until_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_expiration_date',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default OsagoDTO;
